import { render, staticRenderFns } from "./lot-add.vue?vue&type=template&id=d52003cc"
import script from "./lot-add.vue?vue&type=script&lang=js"
export * from "./lot-add.vue?vue&type=script&lang=js"
import style0 from "./lot-add.vue?vue&type=style&index=0&id=d52003cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports